import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import {
  IReasonDialogData,
  IReasonDialogResult,
} from '@app/core/interfaces/reason-dialog.interface';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonComponent } from 'ngx-mt-ui-lib/components/button';
import { CommentComponent } from 'ngx-mt-ui-lib/components/comment';
import { DividerComponent } from 'ngx-mt-ui-lib/components/divider';
import { FieldComponent } from 'ngx-mt-ui-lib/components/field';
import { TextareaComponent } from 'ngx-mt-ui-lib/components/textarea';
import { ControlStateToErrorDirective } from 'ngx-mt-ui-lib/directives/control-state-to-error';

@Component({
  selector: 'app-reason-dialog',
  imports: [
    TranslatePipe,
    ButtonComponent,
    ReactiveFormsModule,
    TextareaComponent,
    FieldComponent,
    DividerComponent,
    CommentComponent,
    ControlStateToErrorDirective,
  ],
  templateUrl: './reason-dialog.component.html',
  styleUrl: './reason-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReasonDialogComponent {
  private readonly dialogRef = inject(DialogRef);
  protected readonly dialogData = inject(DIALOG_DATA) as IReasonDialogData;

  protected readonly form = new FormGroup({
    reason: new FormControl<string | null>(null, [Validators.required]),
  });

  protected cancel(): void {
    this.dialogRef.close();
  }

  protected apply(): void {
    const value = this.form.value;

    if (this.form.invalid) {
      Object.values(this.form.controls).forEach((c) => {
        c.markAsTouched();
        c.updateValueAndValidity();
      });

      return;
    }

    this.dialogRef.close({
      reason: value.reason,
    } satisfies IReasonDialogResult);
  }
}
